export default "__VITE_ASSET__BdBGvOcF__"